<script lang="ts">
  type Button = {
    id: string;
    style: 'secondary' | 'primary';
    label: string;
    type: 'button' | 'submit';
    className?: string;
    buttonclick: (e: Event) => void;
  };

  let { id, style, label, type, className, buttonclick } = $props();
</script>

<div class="submit-button-wrapper">
  <button {type} {style} aria-label={label} class={className} onclick={buttonclick}>
    {label}
  </button>
</div>
